import React from 'react'
import Calls from "../../server/Calls";
import DashboardCalendar from "../dashboards/DashboardCalendar";
import Button from "@material-ui/core/es/Button/Button";
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import InputLabel from "@material-ui/core/es/InputLabel/InputLabel";
import FormControl from "@material-ui/core/es/FormControl/FormControl";

const styles = theme => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    formControl: {
        // margin: theme.spacing(1),
        minWidth: 8000,
    },
    selectEmpty: {
        // marginTop: theme.spacing(2),
    },
});

class RaceEditForm extends React.Component {

    state = {
        races: [],
        place: '',
        date: {undefined},
        text: '',
        raceType: '',
        isFormVisible: true,
        btnText: 'Přidat',
        disc: '',
        discip: [{num: 1, val: 'běh na lyžích'}, {num: 2, val: 'běh'}, {num: 3, val: 'Auta'}, {
            num: 4, val: 'MTB\&Ostatní'}, {num: 5, val: 'Sjezdy'}]
    };

    componentDidMount() {
        this.update();
    }

    constructor() {
        super();
        this.onHandleChange = this.onHandleChange.bind(this);
    }

    update() {
        Calls.getRace()
            .then(response => {
                const races = response.data;
                this.setState({races: races});
                console.log(races);
            })
            .catch(err => {
                console.log(err);
            });
    }

    deleteRace = (raceId) => {
        console.log('Calls.deleteRace(idZavodu): ' + raceId);
        Calls.deleteRaceById(raceId).then(response => {
            console.log(response);
            this.update();
        }).catch(err => {
            console.log(err);
        });
    };

    editRace = (race) => {
        // console.log("otevri formular pro editaci");
        console.log("edituji: " + race.id);
        this.setState({
            place: race.misto,
            date: new Date(race.datum * 1000).toISOString().substr(0, 10),
            text: race.nazev,
            raceType: race.discipl,
            btnText: "Upravit závod"
        });
        // console.log(new Date(race.datum * 1000));
        this.setState(() => ({isFormVisible: true}));
        Calls.updateRace(race.id, race);

    };
    addRace = (place, date, text, raceType) => {
        let dat = new Date(date) / 1000;
        const race = {
            misto: place,
            discipl: "běh",
            datum: dat,
            nazev: text,
            drSou: "beh",
            popis: raceType
        };
        this.crtRace(race);
        // console.log("add new Race: " + place, dat, text, raceType);
        this.setState({
            place: '',
            date: {undefined},
            text: '',
            raceType: '',
            disc: ''
        })

    };

    onHandleChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        });
        // console.log(event.target.name);
        // console.log(event.target.value);
    }

    crtRace = (race) => {
        Calls.createRace(race)
            .then((response) => {
                console.log(response);
                this.update();
            })
            .catch(error => {
                console.log(error)
            });
        this.update();
    };

    setDefaultValue = () => {
        this.setState({
            isFormVisible: false,
            place: '',
            date: {undefined},
            text: '',
            raceType: '',
            disc: ''
        });
    };


    render() {
        const classes = styles();
        const races = this.state.races;
        races.sort((a, b) => {
                return b.datum - a.datum;
            }
        );
        const btnAdd = <Button
            onClick={() => this.state.isFormVisible ? this.setState(() => ({isFormVisible: false})) : this.setState({isFormVisible: true})}>
            {this.state.isFormVisible ? "Skrýt formulář" : "Zobrazit formulář"}</Button>;
        const btnClose = <Button onClick={() => (this.setDefaultValue())}>Close</Button>;
        return <div>
            {btnAdd}{btnClose}
            {this.state.isFormVisible &&
            <form className={classes.root} autoComplete={'off'}>
                <FormControl variant="filled" className={classes.formControl}>
                <TextField type="text" label={"Místo"} onChange={this.onHandleChange} value={this.state.place}
                           name="place"/>
                <TextField type="date" label={"Datum"} onChange={this.onHandleChange} value={this.state.date}
                           name="date"/>
                <TextField type="text" label={"Popisek závodu"} onChange={this.onHandleChange} value={this.state.text}
                           name="text"/>
                <TextField type="text" label={"Druh závodu pro rang"} onChange={this.onHandleChange}
                           value={this.state.raceType}
                           name="raceType"/>
                    <InputLabel id="label-disciplina">Disciplína</InputLabel>
                    <Select value={this.state.disc} displayEmpty name="disc"
                            onChange={this.onHandleChange}
                            labelId="label-disciplina"
                            >

                        {this.state.discip.map((key, index) => {
                            return <MenuItem key={index} value={key.num}>{key.val}</MenuItem>
                        })}
                    </Select>
                    {/*<InputLabel>Disciplína</InputLabel>*/}
                </FormControl>

                <Button
                    onClick={() => this.addRace(this.state.place, this.state.date, this.state.text, this.state.raceType)}>
                    {this.state.btnText}
                </Button>

            </form>
            }
            <div>
                <span>Datum</span>
                <span>Místo</span>
                <span>Název</span>
                <span>Druh závodu</span>
                <span>Druh souteze, kvuli rangliste</span>
                <span>stav zavodu - startovka, online&hellip;</span>
            </div>

            {races.map((r) => (
                <div>
                    <span>{DashboardCalendar.getDate(r.datum)}</span>
                    <span>{r.misto}</span>
                    <span>{r.nazev}</span>
                    <span>{r.discipl}</span>
                    <span>{r.drSou}</span>
                    <span><Button onClick={() => this.editRace(r)}>Edit</Button></span>
                    <span><Button onClick={() => this.deleteRace(r.id)}>Smazat</Button></span>
                </div>
            ))}
        </div>
    }
}

export default RaceEditForm;